import { Component, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MenuItem } from '@openng/optimus-ui/api';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { SortUsersDirection } from '../../../enum/user-management/sort-users-direction.enum';
import { SortUsersBy } from '../../../enum/user-management/sort-users-by.enum';
import { FilterUsersDirectCare } from '../../../enum/user-management/filter-users-direct-care.enum';
import { FilterUsersActiveToday } from '../../../enum/user-management/filter-users-active-today.enum';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { Store } from '@ngrx/store';
import { isAllowed, translate } from '../../../../shared/shared.global-service';
import { CreateUserDialogComponent } from '../create-user-dialog/create-user-dialog.component';
import { UserHeaderButtonsStore } from './user-header-buttons.store';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { SplitButtonModule } from '@openng/optimus-ui/splitbutton';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../../components/kit/button/button.component';

@Component({
    selector: 'app-users-header-buttons',
    templateUrl: './users-header-buttons.component.html',
    imports: [
        ButtonComponent,
        SplitButtonModule,
        TranslatePipe,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [UserHeaderButtonsStore],
})
export class UsersHeaderButtonsComponent extends SubscriptionComponent implements OnInit {
    private translate = inject(TranslateService);
    protected readonly store = inject(Store);


    public readonly dialogService = inject(BaseDialogService);
    public readonly store2 = inject(UserHeaderButtonsStore);

    @Input({ required: true }) form!: FormGroup;

    sortOptions: MenuItem[] = [];
    sortButtonLabel!: string;
    sortButtonIcon!: string;

    ngOnInit() {
        this.generateSortOptions();
        this.subs.push(
            this.translate.onLangChange.subscribe(() => {
                this.generateSortOptions();
            }),
        );
    }

    sortButtonClicked(): void {
        if (this.form.get('sortBy')?.value !== SortUsersBy.NoSort) {
            this.form.patchValue({
                sortDirection: this.form.get('sortDirection')?.value === SortUsersDirection.ASC ? SortUsersDirection.DESC : SortUsersDirection.ASC,
            });
            this.sortButtonIcon = this.getIconForSortingOption(this.form.get('sortBy')?.value ?? SortUsersBy.NoSort);
            this.generateSortOptions();
        }
    }

    generateSortOptions(): void {
        const sortOptionsLabels = [
            'database.usersPage.sortOptions.byReportedWork',
            'database.usersPage.sortOptions.bySurnameAndName',
            'database.usersPage.sortOptions.byWorkingTimeSize',
            'database.usersPage.sortOptions.showOnlyDirectCare',
            'database.usersPage.sortOptions.showOnlyDirectCareOptions.doesNotMatter',
            'database.usersPage.sortOptions.showOnlyDirectCareOptions.showOnlyDirectCare',
            'database.usersPage.sortOptions.showOnlyDirectCareOptions.hideDirectCare',
            'database.usersPage.sortOptions.showOnlyActiveToday',
            'database.usersPage.sortOptions.showOnlyActiveTodayOptions.doesNotMatter',
            'database.usersPage.sortOptions.showOnlyActiveTodayOptions.showOnlyActiveToday',
            'database.usersPage.sortOptions.showOnlyActiveTodayOptions.hideActiveToday',
        ];

        this.translate
            .get(sortOptionsLabels)
            .subscribe((translations: Record<string, string>) => {
                this.sortOptions = [
                    // {
                    //     label: translations['database.usersPage.sortOptions.byReportedWork'],
                    //     icon: this.getIconForSortingOption(SortUsersBy.ReportedWork),
                    //     command: () => {
                    //         this.form.patchValue({
                    //             sortDirection:
                    //                 this.form.get('sortBy')?.value === SortUsersBy.ReportedWork &&
                    //                 this.form.get('sortDirection')?.value === SortUsersDirection.DESC
                    //                     ? SortUsersDirection.ASC
                    //                     : SortUsersDirection.DESC,
                    //             sortBy: SortUsersBy.ReportedWork,
                    //         });
                    //         this.sortButtonLabel = translations['database.usersPage.sortOptions.byReportedWork'];
                    //         this.sortButtonIcon = this.getIconForSortingOption(SortUsersBy.ReportedWork);
                    //         this.generateSortOptions();
                    //     },
                    // },
                    {
                        label: translations['database.usersPage.sortOptions.bySurnameAndName'],
                        icon: this.getIconForSortingOption(SortUsersBy.SurnameAndName),
                        command: () => {
                            this.form.patchValue({
                                sortDirection:
                                    this.form.get('sortBy')?.value === SortUsersBy.SurnameAndName &&
                                    this.form.get('sortDirection')?.value === SortUsersDirection.ASC
                                        ? SortUsersDirection.DESC
                                        : SortUsersDirection.ASC,
                                sortBy: SortUsersBy.SurnameAndName,
                            });
                            this.sortButtonLabel = translations['database.usersPage.sortOptions.bySurnameAndName'];
                            this.sortButtonIcon = this.getIconForSortingOption(SortUsersBy.SurnameAndName);
                            this.generateSortOptions();
                        },
                    },
                    // {
                    //     label: translations['database.usersPage.sortOptions.byWorkingTimeSize'],
                    //     icon: this.getIconForSortingOption(SortUsersBy.WorkingTimeSize),
                    //     command: () => {
                    //         this.form.patchValue({
                    //             sortDirection:
                    //                 this.form.get('sortBy')?.value === SortUsersBy.WorkingTimeSize &&
                    //                 this.form.get('sortDirection')?.value === SortUsersDirection.DESC
                    //                     ? SortUsersDirection.ASC
                    //                     : SortUsersDirection.DESC,
                    //             sortBy: SortUsersBy.WorkingTimeSize,
                    //         });
                    //         this.sortButtonLabel = translations['database.usersPage.sortOptions.byWorkingTimeSize'];
                    //         this.sortButtonIcon = this.getIconForSortingOption(SortUsersBy.WorkingTimeSize);
                    //         this.generateSortOptions();
                    //     },
                    // },
                    // {
                    //     label: translations['database.usersPage.sortOptions.showOnlyDirectCare'],
                    //     icon: 'pi pi-cog',
                    //     items: [
                    //         {
                    //             label: translations['database.usersPage.sortOptions.showOnlyDirectCareOptions.doesNotMatter'],
                    //             icon: 'pi pi-circle',
                    //             styleClass: this.getClassForFilteringOption(FilterUsersDirectCare.NoMatter),
                    //             command: () => {
                    //                 this.form.patchValue({
                    //                     filterDirectCare: FilterUsersDirectCare.NoMatter,
                    //                 });
                    //                 this.generateSortOptions();
                    //             },
                    //         },
                    //         {
                    //             label: translations['database.usersPage.sortOptions.showOnlyDirectCareOptions.showOnlyDirectCare'],
                    //             icon: 'pi pi-check-circle',
                    //             styleClass: this.getClassForFilteringOption(FilterUsersDirectCare.OnlyDC),
                    //             command: () => {
                    //                 this.form.patchValue({
                    //                     filterDirectCare: FilterUsersDirectCare.OnlyDC,
                    //                 });
                    //                 this.generateSortOptions();
                    //             },
                    //         },
                    //         {
                    //             label: translations['database.usersPage.sortOptions.showOnlyDirectCareOptions.hideDirectCare'],
                    //             icon: 'pi pi-times-circle',
                    //             styleClass: this.getClassForFilteringOption(FilterUsersDirectCare.HideDC),
                    //             command: () => {
                    //                 this.form.patchValue({
                    //                     filterDirectCare: FilterUsersDirectCare.HideDC,
                    //                 });
                    //                 this.generateSortOptions();
                    //             },
                    //         },
                    //     ],
                    // },
                    // {
                    //     label: translations['database.usersPage.sortOptions.showOnlyActiveToday'],
                    //     icon: 'pi pi-cog',
                    //     items: [
                    //         {
                    //             label: translations['database.usersPage.sortOptions.showOnlyActiveTodayOptions.doesNotMatter'],
                    //             icon: 'pi pi-circle',
                    //             styleClass: this.getClassForFilteringOption(FilterUsersActiveToday.NoMatter),
                    //             command: () => {
                    //                 this.form.patchValue({
                    //                     filterActiveToday: FilterUsersActiveToday.NoMatter,
                    //                 });
                    //                 this.generateSortOptions();
                    //             },
                    //         },
                    //         {
                    //             label: translations['database.usersPage.sortOptions.showOnlyActiveTodayOptions.showOnlyActiveToday'],
                    //             icon: 'pi pi-check-circle',
                    //             styleClass: this.getClassForFilteringOption(FilterUsersActiveToday.ActiveToday),
                    //             command: () => {
                    //                 this.form.patchValue({
                    //                     filterActiveToday: FilterUsersActiveToday.ActiveToday,
                    //                 });
                    //                 this.generateSortOptions();
                    //             },
                    //         },
                    //         {
                    //             label: translations['database.usersPage.sortOptions.showOnlyActiveTodayOptions.hideActiveToday'],
                    //             icon: 'pi pi-times-circle',
                    //             styleClass: this.getClassForFilteringOption(FilterUsersActiveToday.InactiveToday),
                    //             command: () => {
                    //                 this.form.patchValue({
                    //                     filterActiveToday: FilterUsersActiveToday.InactiveToday,
                    //                 });
                    //                 this.generateSortOptions();
                    //             },
                    //         },
                    //     ],
                    // },
                ];
            });
    }

    getIconForSortingOption(sortOption: SortUsersBy): string {
        // pi pi-sort-(amount|alpha)-(up|down)'

        if (sortOption === SortUsersBy.ReportedWork || sortOption === SortUsersBy.WorkingTimeSize) {
            if (sortOption === this.form.get('sortBy')?.value && this.form.get('sortDirection')?.value === SortUsersDirection.DESC) {
                return 'pi pi-sort-amount-up';
            }

            return 'pi pi-sort-amount-down';
        }
        if (sortOption === SortUsersBy.SurnameAndName) {
            if (sortOption === this.form.get('sortBy')?.value && this.form.get('sortDirection')?.value === SortUsersDirection.ASC) {
                return 'pi pi-sort-alpha-up';
            }

            return 'pi pi-sort-alpha-down';
        }

        return '';
    }

    getClassForFilteringOption(filteringOption: FilterUsersActiveToday | FilterUsersDirectCare): string {
        if (filteringOption === this.form.get('filterDirectCare')?.value || filteringOption === this.form.get('filterActiveToday')?.value) {
            return 'surface-300';
        }

        return '';
    }

    protected createNew(): void {
        this.dialogService.open(
            CreateUserDialogComponent,
            {
                header: translate.instant('user.createUser.title'),
                styleClass: 'p-dialog-width-70',
            },
        );
    }

    protected readonly isAllowed = isAllowed;
}
